    @if (params.valueFormatted == "_???addRow???_") {
        <button pButton type="button" class="p-button-text" icon="fas fa-plus" (click)="addRow()"></button>
    }
    @else {
        @switch (column.cellType) {
            @case (_TableCellType.button) {
                @for (button of params.value; track button) {
                    @if (button != null && button.visible) {
                        <button pButton type="button" class="p-button-text" [icon]="button.icon" [pTooltip]="button.description" (click)="buttonClick($event, button)"></button>
                    }
                }
            }
            @case (_TableCellType.color) {
                <span class="badge m-1" [style.background]="_Utils.toColorHexString(params.value)" [class.no-wrap-cell]="false">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            }
            @case (_TableCellType.link) {
                <span><a href="#" (click)="buttonClick($event, null)">{{params.value}}</a></span>
            }
            @default {
                @if (getKeepHtml()) {
                    <span #value class="content" [tp]="toolTip?.getComponentOnHover()" [tpData]="toolTip?.data" [tpDelay]="[500, 0]" tpPlacement="auto" tpBoundary="viewport" tpVariation="tooltip" appDynamicTooltip="toolTip?.getComponentOnHover() == null" (onToolTip)="handleTooltip($event)" [innerHTML]="displayValue"></span>
                }
                @else {
                    <span #value class="content" [tp]="toolTip?.getComponentOnHover()" [tpData]="toolTip?.data" [tpDelay]="[500, 0]" tpPlacement="auto" tpBoundary="viewport" tpVariation="tooltip" appDynamicTooltip="toolTip?.getComponentOnHover() == null" (onToolTip)="handleTooltip($event)">{{displayValue}}</span>
                }
            }
        }
        @if (mouseInside && (params.colDef.context.table.actionButtons || buttonActions?.length > 0)) {
            <div class="action-buttons-container">
                @if (tableCell?.actionsAsContextMenu) {
                    <button pButton type="button" class="action-button p-button-text" icon="fas fa-bars" (click)="actionContextMenuButtonClick($event)"></button>
                }
                @else {
                    @for (action of buttonActions; track action) {
                        <button pButton type="button" class="action-button p-button-text" [pTooltip]="action.getCaption()" [icon]="action.getIcon()" (click)="actionButtonClick($event, action)"></button>
                    }
                }
                @if (params.colDef.context.table.actionButtons) {
                    <button pButton type="button" class="action-button action-context-button p-button-text" icon="fas fa-bars" (click)="actionContextButtonClick($event)"></button>
                }
            </div>
        }
    }
